import { message } from 'antd';
import classNames from 'classnames';
import React, { memo, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { useLocation, useHistory } from 'react-router-dom';
import styles from './SearchTab.module.less';

import { cacheKeys } from '../../constants/storageKeys';
import { softType, softCategory, wallpaperDpi, wallpaperPay, postType, coursePay } from './config';
import Dialog from '../../components/Dialog/Dialog';
import Select from '../../components/SelectSearsh/Select';
import Toast from '../../components/Toast/Toast';
import { logging, logPostInfo } from '../../actions/log';
import { updateSearchParam } from '../../actions/searchResult';
import { getFeedbackSuggest, setFeedbackVisible, setIsSearchClick } from '../../actions/search';

import Loading from '../../components/Loading/Loading';
import { getQueryString } from '../../utils/utils';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const selectSearchInfo = createSelector(
  state => state.search,
  search => search,
);
const selectSearchKw = createSelector(
  state => state.layout,
  layout => layout.searchKw,
);

const selectSearchResultObj = createSelector(
  state => state.searchResult,
  searchResult => searchResult,
);

export default memo(({ logInfo }) => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const {
    searchParam,
    searchCount,
    searchSoft,
    searchWallpaper,
    searchPost,
    searchCourse,
  } = useSelector(selectSearchResultObj);

  const [feedbackSuggestRef, setFeedbackSuggestRef] = useState(null);
  const [feedbackSuggestcontent, setFeedbackSuggestcontent] = useState(null);
  const searchKw = useSelector(selectSearchKw);
  const { searchRecommend, searchResult, feedbackVisible } = useSelector(selectSearchInfo);

  const [activeTab, setActiveTab] = useState('soft');

  const [sortTypeSel, setSortTypeSel] = useState(softType[0].name);
  const [softCategorySel, setSoftCategorySel] = useState(softCategory[0].name);
  const [wallpaperDpiSel, setWallpaperDpiSel] = useState(wallpaperDpi[0].name);
  const [wallpaperPaySel, setWallpaperPaySel] = useState(wallpaperPay[0].name);
  const [postTypeSel, setPostTypeSel] = useState(postType[0].name);
  const [coursePaySel, setCoursePaySel] = useState(coursePay[0].name);
  const [sortTypeDef, setSortTypeDef] = useState(softType[0]);
  const [softCategoryDef, setSoftCategoryDef] = useState(softCategory[0]);
  const [wallpaperDpiDef, setWallpaperDpiDef] = useState(wallpaperDpi[0]);
  const [wallpaperPayDef, setWallpaperPayDef] = useState(wallpaperPay[0]);
  const [postTypeDef, setPostTypeDef] = useState(postType[0]);
  const [coursePayDef, setCoursePayDef] = useState(coursePay[0]);

  const keyword = getQueryString('keyword');
  const firstId = getQueryString('firstId');
  const androidType = getQueryString('androidType');

  /**
   * 解决一个bug, 当重新搜索的时候，选中项不会发生变化
   * 思路：当重新搜索的时候，由于外部组件触发的，所以只能通过通过location的变化===搜索词的变化
   * 重置一次默认选中项为第二项，100毫秒之后再重置回来，从而控制重新搜索的时候，下拉框选择默认值
   */
  useEffect(() => {
    setTimeout(() => {
      setSortTypeDef(softType[1]);
      setSoftCategoryDef(softCategory[1]);
      setWallpaperDpiDef(wallpaperDpi[1]);
      setWallpaperPayDef(wallpaperPay[1]);
      setPostTypeDef(postType[1]);
      setCoursePayDef(coursePay[1]);
      setTimeout(() => {
        setSortTypeDef(softType[0]);
        setSoftCategoryDef(softCategory[0]);
        setWallpaperDpiDef(wallpaperDpi[0]);
        setWallpaperPayDef(wallpaperPay[0]);
        setPostTypeDef(postType[0]);
        setCoursePayDef(coursePay[0]);
      }, 100);
    }, 200);
  }, [location]);

  // 当外部改变tab的时候
  useEffect(() => {
    setActiveTab(searchParam.activeTab);
  }, [searchParam]);

  // 用户点击改变tab
  const handleChangeTab = useCallback(
    tab => {
      if (activeTab === tab) {
        return;
      }
      let param = {
        searchWord: getQueryString('keyword'),
        searchMode: '1',
        activeTab: tab,
        sortTypeSel,
        softCategorySel,
        wallpaperDpiSel,
        wallpaperPaySel,
        postTypeSel,
        coursePaySel,
      };

      setActiveTab(tab);
      // 根据选中的菜单重置赛选条件为默认值
      if (tab === 'soft') {
        param.sortTypeSel = softType[0].name;
        param.softCategorySel = softCategory[0].name;
        setSortTypeSel(softType[0].name);
        setSoftCategorySel(softCategory[0].name);
      } else if (tab === 'wallpaper') {
        param.wallpaperDpiSel = wallpaperDpi[0].name;
        param.wallpaperPaySel = wallpaperPay[0].name;
        setWallpaperDpiSel(wallpaperDpi[0].name);
        setWallpaperPaySel(wallpaperPay[0].name);
      } else if (tab === 'post') {
        param.postTypeSel = postType[0].name;
        setPostTypeSel(postType[0].name);
      } else if (tab === 'course') {
        param.coursePaySel = coursePay[0].name;
        setCoursePaySel(coursePay[0].name);
      }

      // 改变tab打桩
      dispatch(
        logging({
          category: 'C',
          action: 'Search_ChangeTab',
          label: '',
          param2: {
            source: 'Search',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            search_type: logInfoData.search_type,
            search_word: logInfoData.search_word || keyword,
            keyword,
            ...param,
          },
        }),
      );
      dispatch(updateSearchParam(param));
    },
    [
      sortTypeSel,
      softCategorySel,
      wallpaperDpiSel,
      wallpaperPaySel,
      postTypeSel,
      coursePaySel,
      activeTab,
    ],
  );
  const handleChange = useCallback(
    option => {
      let param = {
        searchWord: getQueryString('keyword'),
        searchMode: '1',
        activeTab,
        sortTypeSel,
        softCategorySel,
        wallpaperDpiSel,
        wallpaperPaySel,
        postTypeSel,
        coursePaySel,
      };
      if (option && option.selectType === 'softType') {
        param.sortTypeSel = option.name;
        setSortTypeSel(option.name);
      } else if (option && option.selectType === 'softCategory') {
        param.softCategorySel = option.name;
        setSoftCategorySel(option.name);
      } else if (option && option.selectType === 'wallpaperDpi') {
        param.wallpaperDpiSel = option.name;
        setWallpaperDpiSel(option.name);
      } else if (option && option.selectType === 'wallpaperPay') {
        param.wallpaperPaySel = option.name;
        setWallpaperPaySel(option.name);
      } else if (option && option.selectType === 'postType') {
        param.postTypeSel = option.name;
        setPostTypeSel(option.name);
      } else if (option && option.selectType === 'coursePay') {
        param.coursePaySel = option.name;
        setCoursePaySel(option.name);
      }

      // 改变筛选条件打桩
      dispatch(
        logging({
          category: 'C',
          action: 'Search_ChangeSelect',
          label: '',
          param2: {
            source: 'Search',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            search_type: logInfoData.search_type,
            search_word: logInfoData.search_word || keyword,
            keyword,
            ...param,
            selectType: option.selectType, // 哪一个筛选条件
          },
        }),
      );
      dispatch(updateSearchParam(param));
    },
    [
      sortTypeSel,
      softCategorySel,
      wallpaperDpiSel,
      wallpaperPaySel,
      postTypeSel,
      coursePaySel,
      activeTab,
    ],
  );

  // 点击反馈
  const handleFeedback = useCallback(() => {
    if (!feedbackVisible) {
      message.destroy();
      // 反馈打桩
      dispatch(
        logging({
          category: 'C',
          action: 'Search_Feedback',
          label: '',
          param2: {
            source: 'Search',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            search_type: logInfoData.search_type,
            search_word: logInfoData.search_word || keyword,
            keyword,
            ...searchParam,
          },
        }),
      );
    }
    if (feedbackVisible) {
      setFeedbackSuggestcontent(null);
      // 反馈打桩关闭
      dispatch(
        logging({
          category: 'C',
          action: 'Search_Feedback_Cancle',
          label: '',
          param2: {
            source: 'Search',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            search_type: logInfoData.search_type,
            search_word: logInfoData.search_word || keyword,
            keyword,
            ...searchParam,
          },
        }),
      );
    }
    dispatch(setFeedbackVisible({ feedbackVisible: !feedbackVisible }));
  }, [feedbackVisible, searchParam]);

  const handleFeedbackSuggest = useCallback(() => {
    const messages = feedbackSuggestRef.value;
    if (!messages) {
      return;
    }
    dispatch(
      getFeedbackSuggest({
        message: messages,
        searchWord: searchKw,
        activeTab,
        searchParam,
      }),
    );

    // 反馈打桩提交
    dispatch(
      logging({
        category: 'C',
        action: 'Search_Feedback_Submit',
        label: '',
        param2: {
          source: 'Search',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          search_type: logInfoData.search_type,
          search_word: logInfoData.search_word || keyword,
          keyword,
          ...searchParam,
        },
      }),
    );
  }, [feedbackSuggestRef, searchKw, searchParam]);

  const handleTextArea = useCallback(() => {
    setFeedbackSuggestcontent(
      feedbackSuggestRef && feedbackSuggestRef.value && feedbackSuggestRef.value.slice(0, 300),
    );
    if (
      feedbackSuggestRef &&
      feedbackSuggestRef.value &&
      feedbackSuggestRef &&
      feedbackSuggestRef.value.length > 300
    ) {
      feedbackSuggestRef.value = feedbackSuggestRef.value.slice(0, 300);
      Toast.error({
        content: '您反馈的内容过多，请将字数控制在300字以内!',
        duration: 2.8,
      });
    }
  });
  let vt = localStorage.getItem(cacheKeys.IS_VT_ENABLE) || '1';
  return (
    <>
      <div className={styles.s_header}>
        <div className={styles.s_header_tab_box}>
          <div className={styles.s_header_tabs}>
            <div
              className={`${styles.s_header_tab_item} ${activeTab === 'soft' &&
                styles.s_tab_active}`}
              onClick={() => {
                handleChangeTab('soft');
              }}
            >
              <span>应用</span>
              <span
                className={`${styles.s_header_num} ${activeTab === 'soft' && styles.s_num_active}`}
              >
                {searchCount?.appsCount > 99 ? '99+' : searchCount?.appsCount || 0}
              </span>
            </div>
            <div
              className={`${styles.s_header_tab_item} ${activeTab === 'wallpaper' &&
                styles.s_tab_active}`}
              onClick={() => {
                handleChangeTab('wallpaper');
              }}
            >
              <span>壁纸</span>
              <span
                className={`${styles.s_header_num} ${activeTab === 'wallpaper' &&
                  styles.s_num_active}`}
              >
                {searchCount?.wallpapersCount > 99 ? '99+' : searchCount?.wallpapersCount || 0}
              </span>
            </div>
            <div
              className={`${styles.s_header_tab_item} ${activeTab === 'post' &&
                styles.s_tab_active}`}
              onClick={() => {
                handleChangeTab('post');
              }}
            >
              <span>文章</span>
              <span
                className={`${styles.s_header_num} ${activeTab === 'post' && styles.s_num_active}`}
              >
                {searchCount?.postsCount > 99 ? '99+' : searchCount?.postsCount || 0}
              </span>
            </div>
            <div
              className={`${styles.s_header_tab_item} ${activeTab === 'course' &&
                styles.s_tab_active}`}
              onClick={() => {
                handleChangeTab('course');
              }}
            >
              <span>课程</span>
              <span
                className={`${styles.s_header_num} ${activeTab === 'course' &&
                  styles.s_num_active}`}
              >
                {searchCount?.coursesCount > 99 ? '99+' : searchCount?.coursesCount || 0}
              </span>
            </div>
          </div>
          <div className={styles.s_header_feedback} onClick={handleFeedback}>
            <i className={` ${styles.s_header_feedback_icon} iconfont icon-feedback1`} />
            搜索反馈
          </div>
        </div>
        <div className={styles.s_header_selects}>
          {activeTab === 'soft' && (
            <div
              style={
                searchParam.sortTypeSel === '0' &&
                searchParam.softCategorySel === '0' &&
                searchSoft?.loading === 200 &&
                searchSoft?.dataList?.length === 0
                  ? { visibility: 'hidden' }
                  : { visibility: 'visible' }
              }
            >
              {vt === '1' && (
                <Select options={softType} defaultValue={sortTypeDef} handleChange={handleChange} />
              )}

              <Select
                options={softCategory}
                defaultValue={softCategoryDef}
                handleChange={handleChange}
              />
            </div>
          )}
          {activeTab === 'wallpaper' && (
            <div
              style={
                searchParam.wallpaperPaySel === '0' &&
                searchWallpaper?.loading === 200 &&
                searchWallpaper?.dataList?.length === 0
                  ? { visibility: 'hidden' }
                  : { visibility: 'visible' }
              }
            >
              <Select
                options={wallpaperPay}
                defaultValue={wallpaperPayDef}
                handleChange={handleChange}
              />
            </div>
          )}
          {activeTab === 'post' && (
            <div
              style={
                searchParam.postTypeSel === '0' &&
                searchPost?.loading === 200 &&
                searchPost?.dataList?.length === 0
                  ? { visibility: 'hidden' }
                  : { visibility: 'visible' }
              }
            >
              <Select options={postType} defaultValue={postTypeDef} handleChange={handleChange} />
            </div>
          )}
          {activeTab === 'course' && (
            <div
              style={
                searchParam.coursePaySel === '0' &&
                searchCourse?.loading === 200 &&
                searchCourse?.dataList?.length === 0
                  ? { visibility: 'hidden' }
                  : { visibility: 'visible' }
              }
            >
              <Select options={coursePay} defaultValue={coursePayDef} handleChange={handleChange} />
            </div>
          )}
        </div>
      </div>
      {feedbackVisible && (
        <Dialog
          maskStyle={styles.mask}
          containerStyle={styles.feedback_modal}
          title="搜索反馈"
          handleClose={handleFeedback}
        >
          <textarea
            className={styles.feeedback_suggest}
            ref={r => setFeedbackSuggestRef(r)}
            onChange={handleTextArea}
            placeholder="找不到您要的内容？搜索遇到问题？请向我们反馈，我们将不断补充优化，谢谢！"
          />
          <div
            className={classNames(styles.feedback_submit_btn, {
              [styles.feedback_submit_btn_disabled]: !feedbackSuggestcontent,
            })}
            onClick={handleFeedbackSuggest}
          >
            发送
          </div>
          <div className={styles.count}>
            {(feedbackSuggestcontent && feedbackSuggestcontent.length) || 0}
            /300
          </div>
        </Dialog>
      )}
    </>
  );
});
